import { CircularProgress } from "@mui/material";

const MiniSpinner = () => {
  return <CircularProgress color="success" />;
};

export default MiniSpinner;
